import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { AnalyzeData } from './model/analyze-data';
import { map, Observable, of, switchMap } from 'rxjs';
import { ChartRow } from './model/chart-row';
import { Router } from '@angular/router';
import { SignalsService } from '@shared/services/signals/signals.service';
import { FlightTotalsService } from '../flights/services/flight-totals.service';
import { formatTime } from '@shared/utilities/utilities';
import { MessageService } from 'primeng/api';
import { ErrorLogService } from '@shared/services/errorhandler/error-log.service';

@Component({
  selector: 'app-analyze',
  standalone: true,
  imports: [
    CommonModule,
    TableModule
  ],
  templateUrl: './analyze.component.html',
  styleUrl: './analyze.component.scss'
})
export class AnalyzeComponent implements OnInit {

  empNumber$ = this.signalsService.employeeNumber$;

  analyzeData$!: Observable<AnalyzeData[]>;
  chartRows: ChartRow[] = [];
  selectedRow!: ChartRow;

  constructor(
    private router: Router,
    private signalsService: SignalsService,
    private flightTotalsService: FlightTotalsService,
    private errorLogService: ErrorLogService
  ) { }

  ngOnInit(): void {

    this.analyzeData$ = this.empNumber$.pipe(
      switchMap((empNum) => {
        return this.flightTotalsService.getFlightTimeStats(empNum)
          .pipe(
            map((flightStats) => {
              if (!flightStats || !flightStats.response) {
                this.errorLogService.logError(`Flight Time Stats Error: ${flightStats.status}`);
                //this.messageSerive.add({ severity: 'error', summary: 'Error', detail: 'No Flight Totals data found!' });
              }
              let analyzeData: AnalyzeData[] = [];
              const data: AnalyzeData = {
                totalTime: {
                  label: 'Total Time',
                  value: formatTime(flightStats.response?.totalTime || 0) || '0:00'
                },
                currentYear: {
                  label: 'Current Year',
                  value: formatTime(flightStats.response?.currentYear || 0) || '0:00'
                },
                currentMonth: {
                  label: 'Current Month',
                  value: formatTime(flightStats.response?.currentMonth || 0) || '0:00'
                },
                lastSixMonths: {
                  label: 'Last 6 Months',
                  value: formatTime(flightStats.response?.lastSixMonths || 0) || '0:00'
                },
                lastTwelveMonths: {
                  label: 'Last 12 Months',
                  value: formatTime(flightStats.response?.lastTwelveMonths || 0) || '0:00'
                },
                totalDistanceFlown: {
                  label: 'Distance Flown',
                  value: flightStats.response?.totalDistance || 0
                },
                totalPassengerCount: {
                  label: 'Passenger Count',
                  value: flightStats.response?.totalPassengerCount || 0
                }

              }
              analyzeData.push(data)
              return analyzeData;
            })
          );
      })

    );
    this.chartRows = this.getChartRows();
  }

  getChartRows(): ChartRow[] {
    const rows: ChartRow[] = [
      {
        id: 0,
        label: 'Time by Year (Bar Chart)',
        link: ''
      },
      {
        id: 1,
        label: 'Time by Seat Position (Pie Chart)',
        link: ''
      },
      {
        id: 2,
        label: 'Time by Aircraft (Pie Chart)',
        link: ''
      },
      {
        id: 3,
        label: 'Time by Month (Combo Chart)',
        link: ''
      }
    ];
    return rows;
  }

  onSelectedRow(selectedChart: Event): void {
    
    sessionStorage.setItem('to', JSON.stringify('analyzeChart'));
    const chartId = (selectedChart as any).id;
    switch (chartId) {
      case 0:
      sessionStorage.setItem('chartId', JSON.stringify(chartId));
      this.router.navigate(['analyze/bar-chart']);
      break;
      case 1:
      sessionStorage.setItem('chartId', JSON.stringify(chartId));
      this.router.navigate(['analyze/pie-chart']);
      break;
      case 2:
      sessionStorage.setItem('chartId', JSON.stringify(chartId));
      this.router.navigate(['analyze/pie-chart']);
      break;
      case 3:
      sessionStorage.setItem('chartId', JSON.stringify(chartId));
      this.router.navigate(['analyze/line-chart']);
      break;
    }
  }

  // updateFlightTotals() {
  //   return this.empNumber$.pipe(
  //     switchMap( (empNum) => {
  //       return this.flightTotalsService.getFlightTimeStats(empNum);
  //     })
  //   ); 
  // }

  // ngOnDestroy() {
  //   this.flightTotals$.unsubscribe();
  // }
}
